export { NestedDocumentBlockLink as Link } from './link'
